export const SET_PURCHASE_COLLECTION = 'PURCHASE/SET_PURCHASE_COLLECTION';
export const SET_SUMMARY_PURCHASES = 'PURCHASE/SET_SUMMARY_PURCHASES';
export const SET_PAGINATION_PURCHASE = 'PURCHASE/SET_PAGINATION_PURCHASE';
export const SET_PURCHASE_TO_SAVE = 'PURCHASE/SET_PURCHASE_TO_SAVE';
export const SET_PURCHASE_FOR_EDIT = 'PURCHASE/SET_PURCHASE_FOR_EDIT';
export const SET_PURCHASE_FROM_IMPORT = 'PURCHASE/SET_PURCHASE_TO_SAVE_FROM_IMPORT';
export const RESET_PURCHASE = 'PURCHASE/RESET_PURCHASE';
export const SET_PRODUCT_OF_PURCHASE_ON_FISCAL_EDIT =
  'PURCHASE/SET_PRODUCT_OF_PURCHASE_ON_FISCAL_EDIT';
export const SET_PRODUCT_OF_PURCHASE_PROPS_ON_EDIT =
  'PURCHASE/SET_PRODUCT_OF_PURCHASE_PROPS_ON_EDIT';
export const SET_PRODUCT_OF_PURCHASE_FISCAL_PROPS = 'PURCHASE/SET_PRODUCT_OF_PURCHASE_FISCAL_PROPS';
export const SET_TOTAL_PURCHASE = 'PURCHASE/SET_TOTAL_PURCHASE';
export const SET_REMAINDER = 'PURCHASE/SET_REMAINDER';
export const SET_IMPORTED_INVOICE = 'PURCHASE/SET_IMPORTED_INVOICE';
export const SET_CFOP_COLLECTION = 'PURCHASE/SET_CFOP_COLLECTION';
export const SET_NATUREZA_ERROR = 'PURCHASE/SET_NATUREZA_ERROR';
export const SET_SUPPLIER = 'PURCHASE/SET_SUPPLIER';
export const SET_SUPPLIER_ERROR = 'PURCHASE/SET_SUPPLIER_ERROR';
export const SET_MATCHED_CFOP_FOR_PURCHASE_TAX_INFORMATION =
  'PURCHASE/SET_MATCHED_CFOP_FOR_PURCHASE_TAX_INFORMATION';
export const SET_MATCHED_CFOP_FOR_PRODUCT_PURCHASE =
  'PURCHASE/SET_MATCHED_CFOP_FOR_PRODUCT_PURCHASE';
export const SET_SHIPPING_COMPANY = 'PURCHASE/SET_SHIPPING_COMPANY';
export const SET_CFOP_FOR_PRODUCT = 'PURCHASE/SET_CFOP_FOR_PRODUCT';
export const SET_DECIMAL_CONFIGURATION = 'PURCHASE/SET_DECIMAL_CONFIGURATION';
export const SET_PRODUCT_ON_PURCHASE_COLLECTION = 'PURCHASE/SET_PRODUCT_ON_PURCHASE_COLLECTION';
export const SET_UNIT_OF_MEASURE = 'PURCHASE/SET_UNIT_OF_MEASURE';
export const SET_CSOSN_FOR_PRODUCT = 'PURCHASE/SET_CSOSN_FOR_PRODUCT';
export const SET_CENQ_FOR_PRODUCT = 'PURCHASE/SET_CENQ_FOR_PRODUCT';
export const SET_ORIGEM_FOR_PRODUCT = 'PURCHASE/SET_ORIGEM_FOR_PRODUCT';
export const SET_CST_FOR_PRODUCT = 'PURCHASE/SET_CST_FOR_PRODUCT';
export const SET_CST_IPI_FOR_PRODUCT = 'PURCHASE/SET_CST_IPI_FOR_PRODUCT';
export const SET_CST_PIS_FOR_PRODUCT = 'PURCHASE/SET_CST_PIS_FOR_PRODUCT';
export const SET_CST_COFINS_FOR_PRODUCT = 'PURCHASE/SET_CST_COFINS_FOR_PRODUCT';
export const SET_IMPORTED_INVOICE_FORM_DATA = 'PURCHASE/SET_IMPORTED_INVOICE_FORM_DATA';
export const SET_TOTAL_CALC_PURCHASE = 'PURCHASE/SET_TOTAL_CALC_PURCHASE';
export const SET_LINKED_DOCUMENTS = 'PURCHASE/SET_LINKED_DOCUMENTS';
export const SET_LINKED_PRODUCTS = 'PURCHASE/SET_LINKED_PRODUCTS';
export const SET_PAYMENT = 'PURCHASE/SET_PAYMENT';
export const SET_INSTALLMENTS_RANGE = 'PURCHASE/SET_INSTALLMENTS_RANGE';
export const SET_SELECTED_NATUREZA = 'PURCHASE/SET_SELECTED_NATUREZA';
